import { Component, Prop, Vue } from "vue-property-decorator";

import { ApiResultFailure } from "@timesheets/common";
import { Form } from "@/utils/Form/Form";
import { GemmaError } from "@gemma/errors";
import { INotify } from "@/utils/Form";
import { RecordAny } from "@gemma/typescript-types";
import { VueSlideoutEvent } from "../vue-slideout";
import { elementScrollIntoView } from "seamless-scroll-polyfill";

@Component({})
export class VueSlideoutForm<
  //
  TFormData extends RecordAny,
  TApiRequestData,
  TResponseData,
  TFailureResponseData
> extends Form<TFormData, TApiRequestData, TResponseData, TFailureResponseData> implements INotify<TFormData, TFailureResponseData> {
  @Prop({
    type: String,
    default: function(this: Vue) {
      this.$options.name;
    },
  })
  id!: string;

  created() {
    this.$vueSlideout.$on("submit-" + this.id, this.submit);
  }

  destroyed() {
    this.$vueSlideout.$off("submit-" + this.id, this.submit);
  }

  async failure<TFailureResponseData>(form: TFormData, errors: GemmaError[], apiResult: ApiResultFailure<TFailureResponseData> | undefined): Promise<void> {
    Vue.nextTick(() => {
      const errors = document.querySelector(".vue-form-slideout." + this.id + " ul.errors");
      if (errors) {
        elementScrollIntoView(errors, { behavior: "smooth", block: "center", inline: "center" });
      }
    });

    const vueSlideoutFailedEvent = new VueSlideoutEvent(`${this.$Events.Failed}-${this.id}`, this.id, this, null, { form, apiResult, errors });
    this.$vueSlideout.$emit(vueSlideoutFailedEvent);
  }

  async success<TResponseData>(data: TResponseData) {
    const succeededEvent = new VueSlideoutEvent(`${this.$Events.Succeeded}-${this.id}`, this.id, this, null, data);
    this.$vueSlideout.$emit(succeededEvent);

    const hideEvent = new VueSlideoutEvent("hide-" + this.id, this.id, this, null, data);
    this.$vueSlideout.$emit(hideEvent);
  }
}
